module.exports = new __parcel__URL__("empty-state-blocks.4f8f7da7.svg").toString();